import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "LeadPaintDataSheet/";

const getLeadPaintDataSheetById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetLeadPaintDataSheetById?jobFormId=' + id, constants.REQUIRE_INTERCEPTORS);

const start = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Start', model, constants.REQUIRE_INTERCEPTORS);

const save = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Save', model, constants.REQUIRE_INTERCEPTORS);

const saveLineItem = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveLineItem', model, constants.REQUIRE_INTERCEPTORS);

const deleteLineItem = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteLineItem?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getReportPdf = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetReportPdf?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getLeadPaintDataSheetById,
    start,
    save,
    saveLineItem,
    deleteLineItem,
    getReportPdf,
}